export const env_extension = process.env.EXTENSION === 'true';
export const env_full_test = process.env.VITEST_FULL === 'true';
export const env_log = process.env.LOG === 'true';
